import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Swal from 'sweetalert2';

const Layout = ({ isAdmin = false }) => {
  useEffect(() => {
    // Initialize loader
    const loader = document.getElementById('loader');
    if (loader) {
      setTimeout(() => {
        loader.classList.remove('show');
      }, 1000);
    }

    // Show notification if passed via state/props
    // This can be triggered from API responses
    if (window.successMessage) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: window.successMessage,
        showConfirmButton: false,
        timer: 2500
      });
      window.successMessage = null;
    }
  }, []);

  return (
    <>
      <Header isAdmin={isAdmin} />
      <main>
        <Outlet />
      </main>
      <Footer isAdmin={isAdmin} />
      
      {/* Pre Loader */}
      <div id="loader" className="show">
        <div className="loader"></div>
      </div>
    </>
  );
};

export default Layout;
